export default __webpack_public_path__ + "static/media/JASKINIA_LOGO.ee879b83.png";